import type { Currency } from '@/api/types/public';
import logger from '@/utils/client-logger';
import type { StateCreator } from 'zustand';
import { DEFAULT_CURRENCY } from '@/domain/currency/utils/defaultCurrency';
import type { Store } from '@/store';
import { persistCurrency } from '@/domain/currency/utils/currencyUtils';
import { CurrencyStatus } from '@/domain/currency/types';
import { isTopWindow } from '@/utils/global/isTopWindow';

export interface CurrencyState {
  currencyList: Currency[]; // 所有币种列表
  currency: Currency; // 当前使用的币种
  currencyStatus: CurrencyStatus; // 币种状态
}

export interface CurrencyActions {
  setCurrencyList: (currencyList: CurrencyState['currencyList']) => void;
  setCurrency: (currency: CurrencyState['currency'], options?: { persist?: boolean }) => void;
  setCurrencyByName: (currencyName: CurrencyState['currency']['name']) => void;
}

export type CurrencySlice = CurrencyState & CurrencyActions;

export const initialCurrencyState: CurrencyState = {
  currencyList: [],
  currency: DEFAULT_CURRENCY,
  currencyStatus: 'unknown',
};

export const createCurrencySlice: StateCreator<Store, [], [], CurrencySlice> = (set, get) => {
  return {
    ...initialCurrencyState,

    setCurrencyList: (currencyList) => set({ currencyList }),

    setCurrency: (currency, options) => {
      if (!currency) return;

      set({ currency: currency, currencyStatus: 'ready' });

      if (options?.persist && isTopWindow()) {
        persistCurrency(currency);
      }
    },

    setCurrencyByName: (currencyName) => {
      const currency = get().currencyList.find((item) => item.name === currencyName);
      if (!currency) {
        logger.error(`Domain currency ${currencyName} not found`);
        return;
      }
      get().setCurrency(currency);
    },
  };
};
